import mitt from 'mitt'

/**
 * 全局事件总线
 * toggleCollapse   切换菜单收缩
 * getAiMenuConfig  获取PC首页菜单配置
 * navigateTo       跳转路由并且高亮Icon
 * openAiMenuTour   打开AI菜单引导
 * handleNewConversation AI助理新建对话
 */
const emitter = mitt()

export default emitter
